import { BulkSelectionControl } from "@design-system/BulkSelectionControl/BulkSelectionControl";
import { Button } from "@design-system/Button/Button";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import commandIslandStyles from "@design-system/CommandIsland/CommandIslandVariants.module.scss";
import { HStack } from "@design-system/HStack/HStack";
import {
    TASK_ACTION_LABELS,
    type TaskActionField,
    type TaskBoardChange,
} from "./taskBoardActions";
import { TaskDueDatePicker, TaskFieldPicker } from "./taskBoardPickers";
import styles from "./BoardPlayground.module.scss";

const FIELD_ACTIONS: readonly TaskActionField[] = [
    "assignee",
    "status",
    "priority",
];

interface TaskBoardBulkBarProps {
    selectedCount: number;
    onClearSelection: () => void;
    /** Runs one change from the action set on every selected task. */
    onChange: (change: TaskBoardChange) => void;
}

/**
 * The board's command bar: shows while cards are selected, like the tasks
 * list's bulk footer, with Assign, Status, Priority and Due date pickers.
 */
export const TaskBoardBulkBar = ({
    selectedCount,
    onClearSelection,
    onChange,
}: TaskBoardBulkBarProps) => (
    <div className={styles.bulkBar}>
        <CommandIsland
            isOpen={selectedCount > 0}
            className={commandIslandStyles.bulkActionsStickyFooter}
        >
            <BulkSelectionControl
                size="md"
                selectedCount={selectedCount}
                onClearSelection={onClearSelection}
            />
            <HStack gap={8}>
                {FIELD_ACTIONS.map((field) => (
                    <TaskFieldPicker
                        key={field}
                        field={field}
                        valueId={null}
                        trigger={
                            <Button
                                variant="primary"
                                size="md"
                                aria-label={TASK_ACTION_LABELS[field]}
                            >
                                {TASK_ACTION_LABELS[field]}
                            </Button>
                        }
                        onChange={onChange}
                    />
                ))}
                <TaskDueDatePicker
                    dueDateOnly={null}
                    trigger={
                        <Button variant="primary" size="md">
                            {TASK_ACTION_LABELS.dueDate}
                        </Button>
                    }
                    onChange={onChange}
                />
            </HStack>
        </CommandIsland>
    </div>
);
